import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm } from '@angular/forms';
import { environment } from '../../../environments/environment';

// declare const grecaptcha: any;

// declare global {
//   interface Window {
//     onNtiRecaptchaResolved?: (token: string) => void;
//     onNtiRecaptchaExpired?: () => void;
//   }
// }

@Component({
  selector: 'app-final-cta',
  templateUrl: './final-cta.component.html',
  styleUrls: ['./final-cta.component.scss']
})
export class FinalCtaComponent {

  public formData = {
    firstname: '',
    lastname: '',
    phone: '',
    email: ''
  };

  public readonly recaptchaSiteKey = environment.recaptchaSiteKey;
  public recaptchaToken = '';
  public isSending = false;
  public submitSuccessMessage = '';
  public submitErrorMessage = '';

  constructor(private http: HttpClient) {

    // window.onNtiRecaptchaResolved = (token: string) => {
    //   this.recaptchaToken = token;
    //   this.submitErrorMessage = '';
    // };

    // window.onNtiRecaptchaExpired = () => {
    //   this.recaptchaToken = '';
    // };
  }

  public submitContact(form: NgForm): void {
    this.submitSuccessMessage = '';
    this.submitErrorMessage = '';

    if (form.invalid) {
      const controls = form.controls;

      if (controls.firstname?.invalid) {
        this.submitErrorMessage = 'Completá el nombre.';
      } else if (controls.lastname?.invalid) {
        this.submitErrorMessage = 'Completá el apellido.';
      } else if (controls.phone?.invalid) {
        this.submitErrorMessage = 'Completá el teléfono.';
      } else if (controls.email?.invalid) {
        this.submitErrorMessage = 'Completá el email con formato correcto.';
      } else {
        this.submitErrorMessage = 'Completá todos los campos obligatorios.';
      }
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(this.formData.email)) {
      this.submitErrorMessage = 'El email no tiene un formato válido.';
      return;
    }

    this.isSending = true;

    const currentPlan = sessionStorage.getItem('ntiSelectedPlan') || 'Basico';
    const contactMessage = `Consulta enviada desde NETiC.\nPlan: ${currentPlan}`;

    if (!this.recaptchaToken) {
      this.submitErrorMessage = 'Por favor completá el reCAPTCHA antes de enviar.';
      return;
    }

    this.http.post<{ success: boolean; result: string }>(
      `${environment.apiBaseUrl}/contacto`,
      {
        firstname: this.formData.firstname,
        lastname: this.formData.lastname,
        phone: this.formData.phone,
        email: this.formData.email,
        message: contactMessage,
        recaptchaToken: this.recaptchaToken
      }
    ).subscribe({
      next: (response) => {
        if (!response?.success) {
          this.submitErrorMessage = response?.result || 'No pudimos enviar tu consulta en este momento. Intentá nuevamente.';
          this.isSending = false;
          return;
        }

        this.submitSuccessMessage = response?.result || 'Consulta enviada correctamente.';
        form.resetForm({
          firstname: '',
          lastname: '',
          phone: '',
          email: ''
        });
        this.recaptchaToken = '';
        this.isSending = false;
      },
      error: () => {
        this.submitErrorMessage = 'No pudimos enviar tu consulta en este momento. Intentá nuevamente.';
        this.isSending = false;
      }
    });
  }

  public onRecaptchaResolved(token: string | null): void {
    this.recaptchaToken = token || '';
    this.submitErrorMessage = '';
  }

  public onRecaptchaExpired(): void {
    this.recaptchaToken = '';
  }

}
